import Base from '../../_config/base';

class Location extends Base {
  constructor(el) {
    super(el);

    this.config = {
      togglerSelector: 'location__tab',
      imageSelector: 'location__image',
      descriptionSelector: 'location__content',
      distanceBtn: '.btn--distances',
      distanceTable: '.distance__table',
      openClass: 'active',
    };

    const tabs = el.getElementsByClassName(this.config.togglerSelector);
    const locationsImages = el.getElementsByClassName(this.config.imageSelector);
    const locationsDescriptions = el.getElementsByClassName(this.config.descriptionSelector);
    const distanceBtn = el.querySelectorAll(this.config.distanceBtn);

    [...tabs].forEach((btn) => {
      btn.addEventListener('click', () => {
        if (btn.classList.contains(this.config.openClass)) return;

        [...tabs].forEach((tab) => {
          if (tab.classList.contains(this.config.openClass)) {
            tab.classList.remove(this.config.openClass);
          } else {
            tab.classList.add(this.config.openClass);
          }
        });
        [...locationsImages].forEach((location) => {
          if (location.classList.contains(this.config.openClass)) {
            location.classList.remove(this.config.openClass);
          } else {
            location.classList.add(this.config.openClass);
          }
        });
        [...locationsDescriptions].forEach((location) => {
          if (location.classList.contains(this.config.openClass)) {
            location.classList.remove(this.config.openClass);
          } else {
            location.classList.add(this.config.openClass);
          }
        });
      });
    });

    distanceBtn.forEach((btn) => {
      btn.addEventListener('click', () => {
        const distanceTable = btn.closest('.location__inner').querySelector(this.config.distanceTable);
        if (distanceTable.classList.contains(this.config.openClass)) {
          distanceTable.classList.remove(this.config.openClass);
        } else {
          distanceTable.classList.add(this.config.openClass);
        }

        const titles = btn.querySelectorAll('.btn--distances-switch');
        [...titles].forEach((title) => {
          if (title.classList.contains(this.config.openClass)) {
            title.classList.remove(this.config.openClass);
          } else {
            title.classList.add(this.config.openClass);
          }
        });
      });
    });
  }
}

Location.className = 'Location';
export default Location;
